  // import LocalizationChangedWithFilter from '@/mixins/LocalizationChangedWithFilter';
  // mixins: [ LocalizationChangedWithFilter ],

export default {
  methods: {
    localizationChanged(localizationId) {
      this.currentFilter = this.filterProperty(this);
      this.getOptions('localization');
    }
  }
};
